import { render, staticRenderFns } from "./MultiplyAwaitingMakeup.vue?vue&type=template&id=952e8038&scoped=true"
import script from "./MultiplyAwaitingMakeup.vue?vue&type=script&lang=js"
export * from "./MultiplyAwaitingMakeup.vue?vue&type=script&lang=js"
import style0 from "./MultiplyAwaitingMakeup.vue?vue&type=style&index=0&id=952e8038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952e8038",
  null
  
)

export default component.exports